export class SystemConfig {
  public apExportSum: boolean;

}
